import { fitTitle, fitDescription } from "@/lib/seo-text";
import { createFileRoute } from "@tanstack/react-router";

import { PageHero } from "@/components/page-parts";
import { FIRM } from "@/lib/firm";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: fitTitle("Privacy Policy | Coastside Law") },
      { name: "description", content: fitDescription("How Coastside Law collects, uses and protects your personal information, including website enquiries and Google Ads measurement.") },
      { property: "og:title", content: fitTitle("Privacy Policy | Coastside Law") },
      { property: "og:description", content: fitDescription("How Coastside Law handles your personal information and website data.") },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "/privacy" }],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <>
      <PageHero eyebrow="Privacy" title="Privacy policy" lead="How Coastside Law handles your personal information." />
      <section className="mx-auto max-w-3xl space-y-6 px-5 py-16 text-sm leading-relaxed text-muted-foreground">
        <div>
          <h2 className="font-serif text-2xl text-foreground">What we collect</h2>
          <p className="mt-2">When you send an enquiry we collect the details you give us (name, email, phone and message) and the page and campaign that brought you to our site. We use this only to respond to you and to understand which of our pages and advertising help people find us. Your enquiry is sent to our solicitors by email.</p>
        </div>
        <div>
          <h2 className="font-serif text-2xl text-foreground">Google Ads measurement</h2>
          <p className="mt-2">We use Google Ads. When you visit our site, Google may set cookies and receive information such as the pages you view, the ad you clicked and whether you sent us an enquiry or tapped our phone number. We use this to measure which ads lead to enquiries and to help Google show our ads to people likely to need our services. We do not send your name, email or phone number to Google.</p>
          <p className="mt-2">Visitors from the European Economic Area, United Kingdom, Switzerland and Canada are not tracked by Google Ads on our site.</p>
          <p className="mt-2">You can learn how Google uses this data at <a className="text-primary underline" href="https://business.safety.google/privacy/">business.safety.google/privacy</a>, control ad personalisation at <a className="text-primary underline" href="https://adssettings.google.com">adssettings.google.com</a>, or block cookies in your browser settings.</p>
        </div>
        <div>
          <h2 className="font-serif text-2xl text-foreground">Access and questions</h2>
          <p className="mt-2">We handle personal information in line with the Privacy Act 1988 (Cth) and our professional obligations of confidentiality. To access or correct your information, or to ask a question, call {FIRM.phone} or contact us through the contact page.</p>
        </div>
      </section>
    </>
  );
}
